import { library } from '@fortawesome/fontawesome-svg-core'
import { faPen, faCheck, faTimes } from '@fortawesome/free-solid-svg-icons'

export default function () {
  library.add(faPen, faCheck, faTimes)
}
